import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { SEOHead, getOrganizationSchema, getWebSiteSchema, getWebPageSchema } from '@/components/base/SEOHead';
import { articles, getHotArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Home() {
  const hotArticles = getHotArticles().slice(0, 5);
  const latestArticles = articles.slice(0, 9);
  const exclusiveArticles = articles.filter((a) => a.isExclusive).slice(0, 3);

  const pageSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      getOrganizationSchema(),
      getWebSiteSchema(),
      getWebPageSchema(
        '五一黑料网 - 51黑料吃瓜网红擦边反差视频 | 每日大赛实时追踪 | 黑料门事件总站',
        '五一黑料网官网汇聚全网最热51黑料吃瓜资源，网红擦边反差视频、每日大赛实时追踪与黑料门事件深度曝光。认准五一黑料网权威发布，免费畅享独家爆料内容！',
        'https://www.51heiliao.com/'
      ),
    ],
  };

  return (
    <>
      <SEOHead
        title="五一黑料网 - 51黑料吃瓜网红擦边反差视频 | 每日大赛实时追踪 | 黑料门事件总站"
        description="五一黑料网官网汇聚全网最热51黑料吃瓜资源，网红擦边反差视频、每日大赛实时追踪与黑料门事件深度曝光。认准五一黑料网权威发布，免费畅享独家爆料内容，连接时刻顺畅不掉线！"
        keywords="五一黑料网,51黑料吃瓜,网红擦边,反差视频,每日大赛,黑料门事件,吃瓜总站,五一黑料,爆料平台,娱乐八卦,网红动态"
        canonicalUrl="https://www.51heiliao.com/"
        schema={pageSchema}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative" aria-label="头条热点">
            <ArticleCard article={articles[0]} variant="hero" />
          </section>

          {/* Breaking News Ticker */}
          <section className="bg-primary-500/90" aria-label="滚动快讯">
            <div className="px-4 md:px-6 py-3 flex items-center gap-3 overflow-hidden">
              <span className="flex-shrink-0 px-2.5 py-1 text-xs font-bold bg-background-50 text-primary-600 rounded whitespace-nowrap">
                最新爆料
              </span>
              <div className="overflow-hidden whitespace-nowrap">
                <div className="inline-flex animate-marquee text-sm text-background-50 font-medium">
                  {[...hotArticles.slice(0, 3), ...hotArticles.slice(0, 3)].map((a, idx) => (
                    <Link key={`${a.id}-${idx}`} to={`/article/${a.id}`} className="hover:underline mx-8 whitespace-nowrap">
                      {a.title}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="px-4 md:px-6 py-8 md:py-10" aria-label="分类导航">
            <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 border border-background-300/30 hover:border-accent-500/40 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
                >
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-500/10 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                    <i className={`${cat.icon} text-lg md:text-xl`}></i>
                  </div>
                  <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-950 whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </section>

          {/* Hot Articles Grid */}
          <section className="px-4 md:px-6 pb-8 md:pb-10" aria-label="热门文章">
            <div className="flex items-center justify-between mb-5 md:mb-6">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  热门推荐
                </h2>
                <p className="text-sm text-foreground-500 mt-1">网友最关注的娱乐资讯</p>
              </div>
              <Link to="/category/daily-contest" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap">
                查看更多 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {hotArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          {/* Stats Banner */}
          <section className="relative mx-4 md:mx-6 mb-8 md:mb-10 rounded-lg overflow-hidden" aria-label="平台数据">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20dark%20geometric%20pattern%20with%20subtle%20gradient%20from%20deep%20green%20to%20black%2C%20modern%20data%20visualization%20background%2C%20futuristic%20grid%20pattern%2C%20minimal%20tech%20aesthetic%2C%20dark%20atmosphere%2C%20professional%20corporate%20style%2C%20clean%20lines%2C%20sophisticated%20design&width=1600&height=400&seq=stats-banner-01&orientation=landscape"
                alt=""
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute inset-0 bg-background-50/80"></div>
            <div className="relative z-10 px-4 md:px-8 py-8 md:py-10 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {[
                { value: '50,000+', label: '独家爆料内容' },
                { value: '1200万+', label: '月活跃用户' },
                { value: '98%', label: '用户满意度' },
                { value: '365天', label: '全年无休更新' },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="font-heading text-2xl md:text-4xl font-bold text-primary-500 mb-1">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </section>

          {/* Latest Articles */}
          <section className="px-4 md:px-6 pb-8 md:pb-10" aria-label="最新资讯">
            <div className="flex items-center justify-between mb-5 md:mb-6">
              <div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  最新资讯
                </h2>
                <p className="text-sm text-foreground-500 mt-1">实时追踪最新娱乐动态</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {latestArticles.slice(3, 12).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </section>

          {/* Exclusive Content Section */}
          <section className="px-4 md:px-6 pb-8 md:pb-10" aria-label="独家内容">
            <div className="bg-background-100 rounded-lg border border-secondary-500/20 p-5 md:p-8">
              <div className="flex items-center gap-2 mb-5 md:mb-6">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-500/10">
                  <i className="ri-vip-crown-line text-secondary-500"></i>
                </div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  独家爆料
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                {exclusiveArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="relative mx-4 md:mx-6 mb-8 md:mb-10 rounded-lg overflow-hidden" aria-label="商务合作">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20modern%20office%20interior%20with%20laptop%20and%20coffee%2C%20professional%20minimalist%20workspace%2C%20warm%20ambient%20lighting%2C%20creative%20agency%20vibe%2C%20stylish%20desk%20setup%2C%20collaboration%20atmosphere%2C%20high%20end%20photography%2C%20clean%20sophisticated%20aesthetic&width=1600&height=500&seq=cta-banner-01&orientation=landscape"
                alt=""
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 to-background-50/60"></div>
            <div className="relative z-10 px-6 md:px-10 py-10 md:py-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                  有料你就来！
                </h2>
                <p className="text-foreground-500 max-w-md">
                  如果你掌握独家娱乐资讯、行业黑幕或网红趣闻，欢迎与我们合作。专业团队保障你的信息安全。
                </p>
              </div>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                立即爆料 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}